import { XIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";

const OutboundFlightEditModal = ({ isOpen, onClose, initialData, onSave }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (initialData) setForm(initialData);
  }, [initialData]);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  if (!isOpen) return null;

  return (
    <ModalWrapper title="Edit Outbound Flight" onClose={onClose}>
      <Input
        label="Airline"
        value={form.airline}
        onChange={(v) => handleChange("airline", v)}
      />
      <Input
        label="Flight No"
        value={form.segment}
        onChange={(v) => handleChange("segment", v)}
      />
      <Input
        label="Departure Time"
        type="datetime-local"
        value={form.departure_time}
        onChange={(v) => handleChange("departure_time", v)}
      />
      <Input
        label="Arrival Time"
        type="datetime-local"
        value={form.arrival_time}
        onChange={(v) => handleChange("arrival_time", v)}
      />
      <Input
        label="Ticket URL"
        value={form.document_url}
        onChange={(v) => handleChange("document_url", v)}
      />

      <Footer onClose={onClose} onSave={() => onSave(form)} />
    </ModalWrapper>
  );
};

const ModalWrapper = ({ title, children, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
    <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-xl">
      <div className="flex justify-between px-6 py-4 border-b border-white/10">
        <h2 className="text-white font-semibold">{title}</h2>
        <button onClick={onClose}>
          <XIcon className="w-5 h-5 text-slate-400" />
        </button>
      </div>

      <div className="px-6 py-5 space-y-4">{children}</div>
    </div>
  </div>
);

const Input = ({ label, value, onChange, type = "text" }) => (
  <div>
    <label className="block text-sm text-slate-300 mb-1">{label}</label>
    <input
      type={type}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white
      focus:outline-none focus:ring-2 focus:ring-pink-500/40"
    />
  </div>
);

const Footer = ({ onClose, onSave }) => (
  <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
    <button
      onClick={onClose}
      className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800"
    >
      Cancel
    </button>

    <button
      onClick={onSave}
      className="px-4 py-2 text-sm rounded-lg text-white bg-pink-600 hover:bg-pink-700"
    >
      Save
    </button>
  </div>
);

export default OutboundFlightEditModal;
